import React, { useState, useEffect } from "react";
import { Form } from "reactstrap";
import IntlMessages from "../helpers/IntlMessages";
import "../ChatWindowNew.css";

export default function ThumbFeedback({
  handleFeedBackResponse,
  handleCancelFeedbackResponse,
  locale,
  changeleaveFeedbackMessage,
  buttonColor,
  gid,
  bearerToken,
  conid,
  formSettings,
  theme,
}) {
  const [inputdata, setInputData] = useState({
    name: "",
    phone: "",
    email: "",
    comment: "",
  });
  const [formSetting, setFormSetting] = useState(null);
  const normalizedLang =
    typeof locale === "string" && locale.toLowerCase() === "zh-tw"
      ? "hk"
      : (locale ?? "");
  useEffect(() => {
    window.addEventListener("message", function (event) {
      if (event.data === "closeDefaultForm") {
        handleCancel();
      }
    });
    if (
      formSettings !== null &&
      formSettings.defaultForms !== null &&
      formSettings.defaultForms.isFeedbackForm === true &&
      formSettings.defaultForms.feedbackFormId !== null &&
      formSettings.defaultForms.feedbackFormId !== ""
    ) {
      // fetch(
      //   `${process.env.REACT_APP_BFF_API}/public/forms/get/${formSettings.defaultForms.feedbackFormId}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Accept: "application/json",
      //       "Content-Type": "application/json",
      //     },
      //   }
      // )
      // console.log("lan", locale, formSettings.defaultForms.feedbackFormId);
      fetch(
        `${process.env.REACT_APP_BFF_API}/public/language/get-by-form-language?formId=${formSettings.defaultForms.feedbackFormId}&languageCode=${normalizedLang}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      )
        .then((response) => response.json())
        .then((json) => {
          var form = json;
          var body = { ...formSettings.defaultForms };
          body.formname = form.name;
          setFormSetting({ ...formSettings, defaultForms: body });
        });
    }
  }, [formSettings]);

  const getPlaceholder = (value) => {
    switch (locale) {
      case "af":
        if (value === "name") {
          return "Jou naam";
        }
        if (value === "phone") {
          return "Jou telefoonnommer";
        }
        if (value === "email") {
          return "Jou epos";
        }
        if (value === "comment") {
          return "'n Kort opsomming van jou versoek";
        }
      case "ar":
        if (value === "name") {
          return "اسمك";
        }
        if (value === "phone") {
          return "رقم تليفونك";
        }
        if (value === "email") {
          return "بريدك الالكتروني";
        }
        if (value === "comment") {
          return "ملخص مختصر لطلبك";
        }
      case "de":
        if (value === "name") {
          return "Ihr Name";
        }
        if (value === "phone") {
          return "Deine Telefonnummer";
        }
        if (value === "email") {
          return "Deine E-Mail";
        }
        if (value === "comment") {
          return "Eine kurze Zusammenfassung Ihrer Anfrage";
        }
      case "es":
        if (value === "name") {
          return "Su nombre";
        }
        if (value === "phone") {
          return "Su número de teléfono";
        }
        if (value === "email") {
          return "Tu correo electrónico";
        }
        if (value === "comment") {
          return "Un breve resumen de su solicitud";
        }
      case "fi":
        if (value === "name") {
          return "Sinun nimesi";
        }
        if (value === "phone") {
          return "Puhelinnumerosi";
        }
        if (value === "email") {
          return "Sähköpostisi";
        }
        if (value === "comment") {
          return "Lyhyt yhteenveto pyynnöstäsi";
        }
      case "fr":
        if (value === "name") {
          return "votre nom";
        }
        if (value === "phone") {
          return "Votre numéro de téléphone";
        }
        if (value === "email") {
          return "Votre e-mail";
        }
        if (value === "comment") {
          return "Un bref résumé de votre demande";
        }
      case "hi":
        if (value === "name") {
          return "आपका नाम";
        }
        if (value === "phone") {
          return "आपका फोन नंबर";
        }
        if (value === "email") {
          return "आपका ईमेल";
        }
        if (value === "comment") {
          return "आपके अनुरोध का संक्षिप्त सारांश";
        }
      case "id":
        if (value === "name") {
          return "Namamu";
        }
        if (value === "phone") {
          return "Nomor telepon Anda";
        }
        if (value === "email") {
          return "Email mu";
        }
        if (value === "comment") {
          return "Ringkasan singkat permintaan Anda";
        }
      case "ja":
        if (value === "name") {
          return "あなたの名前";
        }
        if (value === "phone") {
          return "あなたの電話番号";
        }
        if (value === "email") {
          return "あなたのメールアドレス";
        }
        if (value === "comment") {
          return "リクエストの簡単な概要";
        }
      case "ko":
        if (value === "name") {
          return "당신의 이름";
        }
        if (value === "phone") {
          return "전화 번호";
        }
        if (value === "email") {
          return "귀하의 이메일";
        }
        if (value === "comment") {
          return "귀하의 요청에 대한 간략한 요약";
        }
      case "mi":
        if (value === "name") {
          return "To Ingoa";
        }
        if (value === "phone") {
          return "To Tau Waea";
        }
        if (value === "email") {
          return "To Email";
        }
        if (value === "comment") {
          return "He whakarāpopototanga poto o tō tono";
        }
      case "ru":
        if (value === "name") {
          return "Ваше имя";
        }
        if (value === "phone") {
          return "Ваш номер телефона";
        }
        if (value === "email") {
          return "Ваш адрес электронной почты";
        }
        if (value === "comment") {
          return "Краткое описание вашего запроса";
        }
      case "tl":
        if (value === "name") {
          return "Ang pangalan mo";
        }
        if (value === "phone") {
          return "Iyong numero ng telepono";
        }
        if (value === "email") {
          return "Ang email mo";
        }
        if (value === "comment") {
          return "Isang maikling buod ng iyong kahilingan";
        }
      case "th":
        if (value === "name") {
          return "ชื่อของคุณ";
        }
        if (value === "phone") {
          return "หมายเลขโทรศัพท์ของคุณ";
        }
        if (value === "email") {
          return "อีเมลของคุณ";
        }
        if (value === "comment") {
          return "สรุปคำขอของคุณโดยย่อ";
        }
      case "vi":
        if (value === "name") {
          return "Tên của bạn";
        }
        if (value === "phone") {
          return "Số điện thoại của bạn";
        }
        if (value === "email") {
          return "Email của bạn";
        }
        if (value === "comment") {
          return "Tóm tắt ngắn gọn về yêu cầu của bạn";
        }
      case "zh":
        if (value === "name") {
          return "你的名字";
        }
        if (value === "phone") {
          return "你的电话号码";
        }
        if (value === "email") {
          return "你的邮件";
        }
        if (value === "comment") {
          return "您的请求的简要摘要";
        }
      case "zh-TW":
        if (value === "name") {
          return "你的名字";
        }
        if (value === "phone") {
          return "你的電話號碼";
        }
        if (value === "email") {
          return "你的郵件";
        }
        if (value === "comment") {
          return "您的請求的簡要摘要";
        }
      default:
        if (value === "name") {
          return "Your Name";
        }
        if (value === "phone") {
          return "Your Phone Number";
        }
        if (value === "email") {
          return "Your Email";
        }
        if (value === "comment") {
          return "A brief summary of your request";
        }
    }
  };
  const handleChange = (e) => {
    if (e.target.name === "name") {
      setInputData({ ...inputdata, name: e.target.value });
    } else if (e.target.name === "phone") {
      setInputData({ ...inputdata, phone: e.target.value });
    } else if (e.target.name === "email") {
      setInputData({ ...inputdata, email: e.target.value });
    } else if (e.target.name === "comment") {
      setInputData({ ...inputdata, comment: e.target.value });
      changeleaveFeedbackMessage(e.target.value);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    var body = "";
    if (inputdata.name !== "") {
      body = body + "\r\n Name: " + inputdata.name;
    }
    if (inputdata.phone !== "") {
      body = body + "\r\n Phone Number: " + inputdata.phone;
    }
    if (inputdata.email !== "") {
      body = body + "\r\n Email: " + inputdata.email;
    }
    if (inputdata.comment !== "") {
      body =
        body + "\r\n A brief summary of your request: " + inputdata.comment;
    }
    handleFeedBackResponse(
      body,
      inputdata.name,
      inputdata.phone,
      inputdata.email,
    );
    setInputData({
      ...inputdata,
      name: "",
      phone: "",
      email: "",
      comment: "",
    });
  };
  const handleCancel = () => {
    setInputData({
      ...inputdata,
      name: "",
      phone: "",
      email: "",
      comment: "",
    });
    handleCancelFeedbackResponse();
  };

  const buttonStyle = {
    backgroundColor: buttonColor,
    borderColor: buttonColor,
  };
  const effectiveTheme = theme;
  const isFullChat = effectiveTheme === "StraightChatFull";
  return (
    <div
      className={`feedback_popup thumb-feedback ${isFullChat ? "full-chat" : ""}`}
      id="feedback_popup_body"
    >
      <h1>
        {formSetting !== null &&
        formSetting.defaultForms !== null &&
        formSetting.defaultForms.isFeedbackForm &&
        formSetting.defaultForms.formname !== null ? (
          formSetting.defaultForms.formname
        ) : (
          <IntlMessages id="feedback.leave.message" />
        )}
      </h1>
      <button type='button'
         aria-label="Feedback close"
         className="feedback_popup-close list-button" onClick={handleCancel}>
        <img src="/res/cross_icon.jpg" width="15" height="15" alt="close feedback"/>
      </button>
      <hr />
      {formSetting !== null && formSetting.defaultForms.isFeedbackForm ? (
        <iframe
          className="feedback-iframe"
          src={`${process.env.REACT_APP_WEBVIEW_URL}/form-view?id=${
            formSetting.defaultForms.feedbackFormId
          }&gid=${gid}&pid=${
            formSetting.propertyId
          }&conversation_id=${conid}&lang=${normalizedLang}&default_form=1`}
        ></iframe>
      ) : (
        <Form onSubmit={(e) => handleSubmit(e)}>
          <div className="input-text">
            <input
              type={"text"}
              className="form-control"
              placeholder={getPlaceholder("name")}
              value={inputdata.name}
              name="name"
              onChange={(e) => handleChange(e)}
              required={"required"}
            ></input>
          </div>
          <div className="input-text">
            <input
              type={"email"}
              className="form-control"
              placeholder={getPlaceholder("email")}
              value={inputdata.email}
              name="email"
              onChange={(e) => handleChange(e)}
              required={"required"}
            ></input>
          </div>
          <div className="input-text">
            <input
              type={"text"}
              className="form-control"
              placeholder={getPlaceholder("phone")}
              value={inputdata.phone}
              name="phone"
              onChange={(e) => handleChange(e)}
              required={"required"}
            ></input>
          </div>
          <div className="input-text">
            <textarea
              className="form-control"
              value={inputdata.comment}
              placeholder={getPlaceholder("comment")}
              name="comment"
              onChange={(e) => handleChange(e)}
              required={"required"}
            ></textarea>
          </div>
          <button
            style={buttonStyle}
            className="feedback-btn-color"
            id="feedback_button"
            type='button'
                    aria-label="Submit Button"
            // onClick={(e) => handleSubmit(e)}
          >
            <IntlMessages id="check.availabity.submit" />
          </button>
          <button type='button'
                    aria-label="Cancel Button" 
                    className="cancelchat_button list-button" onClick={() => handleCancel()}>
            <IntlMessages id="check.availabity.cancel" />
          </button>
        </Form>
      )}
    </div>
  );
}
